export default "__VITE_ASSET__C0Mqb8hM__"